import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import Button from 'Components/UI/Button';
import useUserContext from 'Context/UserContext';
import { displaySuccess, displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { Tooltip } from '@material-ui/core';

const styles = ({
  root: {
  },
});

function SaveQueryButton({
  classes, className, buttonText, link, queryName, tooltipText, ...rest
}) {
  const { agentResource, isAgent, refreshAgent } = useUserContext();
  const [savedQuery, setSavedQuery] = React.useState(null);
  const url = new URL(link);

  React.useEffect(() => {
    if (isAgent) {
      const rel = agentResource?.relationship('savedQueries')?.link('related');
      if (rel) {
        rel.get().then((col) => setSavedQuery(col.create()));
      }
    }
  }, [isAgent]);

  if (!savedQuery) return null;

  const handleSaveQuery = () => {
    savedQuery.attr('name', queryName);
    savedQuery.attr('path', url.pathname);
    savedQuery.attr('query', url.search.substr(1));
    savedQuery.submit().then(() => displaySuccess('Saved as default')).then(() => refreshAgent()).catch((e) => displayErrorMessage(e));
  };

  return (
    <Tooltip title={tooltipText} arrow>
      <Button classes={classes} className={className} onClick={handleSaveQuery} color="primary" variant="contained" fullWidth {...rest}>
        {buttonText}
      </Button>
    </Tooltip>
  );
}

SaveQueryButton.defaultProps = {
  className: '',
  buttonText: 'Set As Default Filters',
  tooltipText: 'This will take your currently applied filters and use them by default when you navigate to this page in the future',
};

SaveQueryButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  queryName: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  tooltipText: PropTypes.string,
};

export default withStyles(styles)(SaveQueryButton);
